import React from "react";
import clsx from "clsx";
import { makeStyles, fade } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import Logo from "../Logo";
import Chatter from "./Links/Chatter";
import Admin from "./Links/Admin";
import SuperAdmin from "./Links/SuperAdmin";
import Advertiser from "./Links/Advertiser";
import Authorize from "../../utils/Authorize";
const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    width: drawerWidth,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(0, 1),
    paddingLeft: 25,
    ...theme.mixins.toolbar,
  },

  navIcon: {
    paddingLeft: 8,
  },
  item: {
    "&.active": {
      background: fade(theme.palette.primary.main, 0.4),
    },
  },
}));

export default function MiniDrawer({ themeToggle, open, setOpen }) {
  const classes = useStyles();

  return (
    <Drawer variant='permanent' className={clsx(classes.drawer)}>
      <div className={classes.toolbar}>
        <Logo style={{ height: 40 }} />
        <IconButton onClick={() => setOpen(false)}>
          <ChevronLeftIcon />
        </IconButton>
      </div>
      <Divider />
      <Authorize roles={[3]}>
        <Chatter sidebar={open} />
      </Authorize>
      <Authorize roles={[4]}>
        <Advertiser sidebar={open} />
      </Authorize>

      <Authorize roles={[5,6]}>
        <SuperAdmin sidebar={open} />
      </Authorize>
    </Drawer>
  );
}
